import styled from "styled-components";

export const Container = styled.div`
width: 100%;
display: flex;
`

export const ContainerTitulo = styled.div`
width: 100%;
display: flex;
flex-direction: column;
justify-content: center;
padding-left: 100px;
padding-top: 100px;
padding-bottom: 100px;
padding-right:0px ;
animation: fadein 1s; 
@keyframes fadein {
 0% {
 opacity:0;
 }
 50%{
 opacity:0.5;
 }
 100% {
 opacity:1;
 }
}

`

export const Titulo = styled.h2`
font-size: 60px;
color: #51c0dc;
margin-top: 5px;
margin-bottom: 5px;
`

export const Parrafo = styled.p`
font-size: 25px;
color: white;
text-align: justify;
`

export const ContainerLogos = styled.div`
width: 100%;
height: 83vh;
display: flex;
flex-wrap: wrap;
flex-direction: column;
justify-content: center;
padding: 100px;
padding-bottom: 0px;
animation: fadein 300ms; 
@keyframes fadein {
 0% {
 opacity:0;
 }
 50%{
 opacity:0.5;
 }
 100% {
 opacity:1;
 }
}
`

export const LogoTech = styled.img`
width: 150px;
height: 130px;
margin: 30px;
`

export const A = styled.a`
&:hover{
    transition: 200ms;
    transform: scale(1.1);
}
`